import { NgModule } from '@angular/core';
// NV Modules
import { NvButtonModule } from './nv-button/nv-button.module';
import { NvDatePickerModule } from './nv-date-picker/nv-date-picker.module';
import { NvDateRangePickerModule } from './nv-date-range-picker/nv-date-range-picker.module';
import { NvDropdownItemModule } from './nv-dropdown-item/nv-dropdown-item.module';
import { NvDropdownModule } from './nv-dropdown/nv-dropdown.module';
import { NvFormFieldModule } from './nv-form-field/nv-form-field.module';
import { NvIconButtonModule } from './nv-icon-button/nv-icon-button.module';
import { NvIconModule } from './nv-icon/nv-icon.module';
import { NvLogoModule } from './nv-logo/nv-logo.module';
import { NvMultipickerModule } from './nv-multi-picker/nv-multi-picker.module';
import { NvNoteModule } from './nv-note/nv-note.module';
import { NvNumboxModule } from './nv-numbox/nv-numbox.module';
import { NvPillButtonModule } from './nv-pill-button/nv-pill-button.module';
import { NvPillModule } from './nv-pill/nv-pill.module';
import { NvSegmentedControlModule } from './nv-segmented-control/nv-segmented-control.module';
import { NvSidebarItemModule } from './nv-sidebar-item/nv-sidebar-item.module';
import { NvSidebarListModule } from './nv-sidebar-list/nv-sidebar-list.module';
import { NvTextboxModule } from './nv-textbox/nv-textbox.module';
import { NvToastModule } from './nv-toast/nv-toast.module';

const modulesArray = [
  NvButtonModule,
  NvButtonModule,
  NvDatePickerModule,
  NvDatePickerModule,
  NvDateRangePickerModule,
  NvDropdownItemModule,
  NvDropdownModule,
  NvFormFieldModule,
  NvIconButtonModule,
  NvIconModule,
  NvIconModule,
  NvLogoModule,
  NvMultipickerModule,
  NvNoteModule,
  NvNumboxModule,
  NvPillButtonModule,
  NvPillButtonModule,
  NvPillModule,
  NvPillModule,
  NvSegmentedControlModule,
  NvSidebarItemModule,
  NvSidebarListModule,
  NvTextboxModule,
  NvToastModule,
];

@NgModule({
  imports: [...modulesArray],
  exports: [...modulesArray],
})
export class NvDesignLibraryModule {}
